export enum PaymentFlow {
  CARD,
  UPLIFT_LOAN,
  HPP
}

export enum HoldMyFareOptionsValue {
  FULL_PAYMENT,
  HOLD_MY_FARE,
}

export interface HoldMyFareOptions {
  description?: string,
  label: string,
  value: HoldMyFareOptionsValue,
}

export enum OrchestrationPaymentStatuses {
  Unknown = 0,
  Unpaid = 1,
  Pending = 2,
  Payed = 3,
  Rejected = 4
}
